import React from "react";
import { Helmet } from "react-helmet";
import Navigation from "../../components/Navigation";
// import { InlineWidget } from "react-calendly";
import tables from "../../assets/tables.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import "./Tour.css";

export default function Tour() {
  return (
    <div className="Tour">
      <Helmet>
        <title>
          Schedule a Tour - Visit Sixth & Main Event Center in Robstown, TX
        </title>

        {/* SEO description */}
        <meta
          name="description"
          content="Schedule your tour today at Sixth & Main Event Center in Robstown, TX. See our venue rental firsthand — with all-inclusive packages complete with décor, seating, and essential event supplies."
        />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Schedule a Tour - Visit Sixth & Main Event Center in Robstown, TX"
        />
        <meta
          property="og:description"
          content="Schedule your tour today at Sixth & Main Event Center in Robstown, TX. See our venue rental firsthand — with all-inclusive packages complete with décor, seating, and essential event supplies."
        />
        <meta
          property="og:image"
          content="https://sixthandmaineventcenter.com/sixthandmaineventcenter.png"
        />
        <meta
          property="og:url"
          content="https://sixthandmaineventcenter.com/tour"
        />
        <meta
          property="og:type"
          content="website"
        />

        {/* Twitter Card */}
        <meta
          name="twitter:card"
          content="summary_large_image"
        />
        <meta
          name="twitter:title"
          content="Schedule a Tour - Visit Sixth & Main Event Center in Robstown, TX"
        />
        <meta
          name="twitter:description"
          content="Plan a visit to Sixth & Main Event Center in Robstown, TX to explore our venue rental space facilities and discuss your event requirements with our staff. Book your tour now."
        />
        <meta
          name="twitter:image"
          content="https://sixthandmaineventcenter.com/sixthandmaineventcenter.png"
        />

        {/* Canonical */}
        <link
          rel="canonical"
          href="https://sixthandmaineventcenter.com/tour"
        />

        {/* JSON-LD structured data */}
        <Helmet>
          {/* ... your existing <title>, <meta>, and <link> tags ... */}

          <script type="application/ld+json">
            {`
              {
                "@context": "https://schema.org",
                "@graph": [
                  {
                    "@type": "Service",
                    "@id": "https://sixthandmaineventcenter.com/tour#service",
                    "name": "Venue Tour",
                    "description": "Schedule a free venue tour at Sixth & Main Event Center in Robstown, TX to explore the space, discuss event requirements, and see what our all-inclusive rental packages include.",
                    "provider": {
                      "@type": "Organization",
                      "name": "Sixth & Main Event Center",
                      "url": "https://sixthandmaineventcenter.com"
                    },
                    "areaServed": {
                      "@type": "Place",
                      "address": {
                        "@type": "PostalAddress",
                        "streetAddress": "101 N 6th St Unit A",
                        "addressLocality": "Robstown",
                        "addressRegion": "TX",
                        "postalCode": "78380",
                        "addressCountry": "US"
                      }
                    }
                  },
                  {
                    "@type": "ScheduleAction",
                    "name": "Schedule a Venue Tour",
                    "description": "Book your venue tour online using our embedded scheduler and discover our event space.",
                    "object": {
                      "@id": "https://sixthandmaineventcenter.com/tour#service"
                    },
                    "target": {
                      "@type": "EntryPoint",
                      "urlTemplate": "https://calendly.com/sixthandmain/venue-tour",
                      "inLanguage": "en-US",
                      "actionPlatform": [
                        "http://schema.org/DesktopWebPlatform",
                        "http://schema.org/MobileWebPlatform"
                      ]
                    },
                    "agent": {
                      "@type": "Organization",
                      "name": "Sixth & Main Event Center",
                      "url": "https://sixthandmaineventcenter.com"
                    },
                    "participant": {
                      "@type": "Person"
                    }
                  }
                ]
              }
            `}
          </script>
        </Helmet>
      </Helmet>
      <div className="hero">
        <Navigation />
        <div>
          <h1 className="text-white text-center px-2">
            Venue tours available,
            <br />
            book yours today!
          </h1>
        </div>
      </div>
      <div
        name="tour"
        className="Tour container d-block m-auto py-5"
      >
        <div className="container my-5">
          <div className="row">
            <div
              className="col-sm-6 my-sm-3 py-4 bg-light"
              id="tour"
            >
              <h2 className="mb-4">Schedule a Tour</h2>
              <p>
                As you tour the venue, you'll notice the versatility of the
                space. The open floor plan allows for easy configuration to
                accommodate your specific event needs.
              </p>

              <iframe
                className="img-fluid mb-3 d-block mx-auto"
                width="560"
                height="315"
                src="https://www.youtube.com/embed/6YAl0zQG7Mc?si=ocSwiPdD1ZfXHruO"
                title="YouTube video player"
                alt="Video tour of Robstown, Texas venue, Sixth & Main Event Center"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen="true"
              ></iframe>

              <p>
                We invite you to come and see for yourself the potential our
                event venue holds for your next special occasion.
              </p>
            </div>
            <div className="col-sm-6 m-0 p-3 pb-0 my-sm-auto">
              <div
                className="px-2 mx-2 rounded"
                style={{ backgroundColor: "#055160" }}
              >
                <p className="text-center py-4 text-light">
                  <FontAwesomeIcon
                    icon={icon({
                      name: "circle-phone",
                      family: "duotone",
                      style: "solid",
                    })}
                    className="me-2"
                  />
                  Please call{" "}
                  <a
                    href="tel:+13617656189"
                    id="telephone"
                    className=""
                  >
                    361-765-6189
                  </a>{" "}
                  to schedule a tour of the venue.
                </p>
              </div>
              <img
                src={tables}
                className="rounded img-fluid my-lg-1"
                alt="Tables in interior layout of Sixth & Main Event Center"
              />
              <p className="mt-1 fw-medium text-center">
                Schedule a tour now to start planning your unforgettable event!
              </p>
              {/* <InlineWidget
                url="https://calendly.com/sixthandmain/venue-tour?hide_event_type_details=1&hide_gdpr_banner=1"
                pageSettings={{
                  primaryColor: "000",
                }}
              /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
